import { fpLogging } from '../../../shared/utils';
import { ERROR_REPORT_START, ERROR_REPORT_SUCCESS, ERROR_REPORT_FAILURE } from './types';

const errorReportStart = (payload) => ({
  type: ERROR_REPORT_START,
  payload,
});

const errorReportFailure = (payload) => ({
  type: ERROR_REPORT_FAILURE,
  payload,
});

const errorReportSuccess = (payload) => ({
  type: ERROR_REPORT_SUCCESS,
  payload,
});

export const doReportError = (title, formId, error, userMessage) => (dispatch) => {
  dispatch(
    errorReportStart({
      sendingError: true,
    })
  );

  try {
    // TODO: Forward user provided message {userMessage} to support
    fpLogging().logErrorToCloudReporting(error);
    dispatch(
      errorReportSuccess({
        sendingError: false,
      })
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    dispatch(
      errorReportFailure({
        sendingError: false,
      })
    );
  }
};

export default {
  doReportError,
};
